import React from 'react';
import PropTypes from 'prop-types';

export default function BookerSendEmail({
  softwares,
  onBookerEmailSent,
  onBack,
  postBoulevardAuthorize,
}) {
  const { bookerAccountInfo } = softwares;
  const emailContent = {
    subject: 'Request Authorization for TrueLark',
    body: `Hi, Boulevard API Team! \n\nI would like to grant API access to TrueLark for my Boulevard Account.\n\nHere are details for my account: \n* Account Name: ${bookerAccountInfo.businessAccount}\n* Location ID: ${bookerAccountInfo.locationID}\n* Primary Contact Name: ${bookerAccountInfo.name}\n* Primary Contact Email Address: ${bookerAccountInfo.email}\n* Address: ${bookerAccountInfo.address}\n Thank You.`,
    to: 'dev-support@blvd.co',
    cc: 'support@truelark.com',
  };
  const clickNext = () => {
    onBookerEmailSent();
    postBoulevardAuthorize(bookerAccountInfo.locationID);
  };

  const mailtoURL = `mailto:${emailContent.to}?subject=${encodeURIComponent(
    emailContent.subject,
  )}&body=${encodeURIComponent(emailContent.body)}&cc=${emailContent.cc}`;

  return (
    <div className="booker-send-email">
      <h4>Request Access</h4>
      <p>
        Please draft and send the following email to Boulevard in order to grant
        TrueLark access to your Boulevard account via API. Granting API access
        allows TrueLark to share key pieces of information with your guests
        (service information, staff availability, etc.) when interacting with
        them; book, reschedule, and cancel appointments; and update your
        schedule accordingly.
      </p>
      <p>
        If you use an email application that&apos;s installed on your computer,
        you can click &quot;Compose Email&quot; below to automatically draft the
        email and then all you have to do is hit send!
      </p>
      <div className="booker-send-email__email">
        <div className="booker-send-email__email__recipients">
          <div className="recipient">
            <span>To</span>
            <p>{emailContent.to}</p>
          </div>

          <div className="recipient">
            <span>CC</span>
            <p>{emailContent.cc}</p>
          </div>
        </div>
        <p className="booker-send-email__email__subject">
          <span>Subject</span>
          {emailContent.subject}
        </p>

        <div className="booker-send-email__email__body">
          {emailContent.body.split('\n').map((text) => {
            return <p>{text}</p>;
          })}
        </div>
      </div>
      <div className="booker-send-email__actions">
        <button
          className="btn btn--secondary btn--lg"
          type="button"
          onClick={onBack}
        >
          Previous
        </button>
        <a
          href={mailtoURL}
          className="btn btn--secondary btn--lg compose-email"
        >
          Compose Email
        </a>
        <button className="btn btn--primary btn--lg" onClick={clickNext}>
          Next
        </button>
      </div>
    </div>
  );
}

BookerSendEmail.propTypes = {
  onBack: PropTypes.func.isRequired,
  onBookerEmailSent: PropTypes.func.isRequired,
  postBoulevardAuthorize: PropTypes.func.isRequired,
  softwares: PropTypes.shape().isRequired,
};
